import type { OrgDraftByStarsSummaryResponse } from '@on3/api';

import styles from './TeamDraftSummary.module.scss';
import { TeamSummaryHeaders } from './TeamSummaryHeaders';
import { TeamSummaryItem } from './TeamSummaryItem';

interface ITeamDraftProps {
  starSummary: OrgDraftByStarsSummaryResponse;
}

export const TeamDraftSummary = ({ starSummary }: ITeamDraftProps) => {
  const {
    natTotalDrafted,
    organization,
    overallStarSummary,
    fiveStarSummary,
    fourStarSummary,
    threeStarSummary,
  } = starSummary || {};

  const starsArray = [
    overallStarSummary,
    fiveStarSummary,
    fourStarSummary,
    threeStarSummary,
  ];

  return (
    <div className={styles.summaryWrapper}>
      <TeamSummaryHeaders
        orgAbbreviation={organization?.abbreviation}
        totalDrafted={natTotalDrafted}
      />
      {starsArray.map((stars, index) => (
        <TeamSummaryItem
          key={index}
          mascot={organization?.mascot}
          orgAbbrev={organization?.abbreviation}
          orgName={organization?.fullName}
          starNum={index}
          stars={stars}
        />
      ))}
    </div>
  );
};
